import script from "./roll-forward-options.vue?vue&type=script&setup=true&lang=ts"
export * from "./roll-forward-options.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__